import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <div>
        <p>developed with ❤ by technobyte</p>
      </div>
    </div>
  );
};

export default Footer;
